var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMutation } from '@tanstack/react-query';
import { logout } from '@linkie/api-client';
const useLogout = ({ mutationConfig } = {}) => {
    const _a = mutationConfig || {}, { onSuccess } = _a, restConfig = __rest(_a, ["onSuccess"]);
    return useMutation(Object.assign(Object.assign({ onSuccess }, restConfig), { mutationFn: logout }));
};
export default useLogout;
//# sourceMappingURL=useLogout.hook.js.map